// Update tripConfirmation travelers when a seat is changed on the confirmation page
// to keep trip configuration data in sync with the latest selection
const updateConfirmationTravelerSeat = ({
  dispatch,
  tripConfirmation,
  doUpdateTripConfirmationTravelers,
  travelerIndex,
  flightNumber,
  seatData,
  updateTripConfirmationTravelers,
}) => {
  if (!doUpdateTripConfirmationTravelers || !tripConfirmation?.travelers) {
    return;
  }

  const updatedTravelers = tripConfirmation.travelers.map((traveler, index) => {
    if (index !== travelerIndex) return traveler;

    return {
      ...traveler,
      travelerPreferences: {
        ...traveler.travelerPreferences,
        flightSeatNumbers: {
          ...((traveler.travelerPreferences || {}).flightSeatNumbers || {}),
          [flightNumber]: seatData,
        },
      },
    };
  });

  dispatch(
    updateTripConfirmationTravelers({
      travelers: updatedTravelers,
    }),
  );
};

export default updateConfirmationTravelerSeat;
